import React from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';

const OptimizedImage = props => {
  const { className, imageUrl } = props;

  let parsedImage;
  // This is because not all of PS is updated yet
  try {
    parsedImage = JSON.parse(imageUrl);
    if (Array.isArray(parsedImage) && parsedImage.length) {
      parsedImage = parsedImage[0];
    }
    if (!parsedImage.alt) {
      parsedImage.alt = '';
    }
  } catch (e) {
    parsedImage = {
      small: imageUrl,
      medium: imageUrl,
      alt: ''
    };
  }

  return (
    <picture>
      <source data-srcset={parsedImage.medium} media="(min-width: 768px)" />
      <source
        data-srcset={`${parsedImage.small} 0.5x`}
        media="(min-width: 480px)"
      />
      <source
        data-srcset={`${parsedImage.small} 0.5x`}
        media="(min-width: 0px)"
      />
      <img
        data-src={parsedImage.small}
        className={`${className} lazyload`}
        alt={parsedImage.alt}
      />
    </picture>
  );
};

OptimizedImage.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string
};
export default OptimizedImage;
